// @ts-strict-ignore
import range from 'lodash/range';
import {Component} from 'panel';

import {apiClient} from 'common/util/api-client';
import {defineAndMakeJsxFactory} from 'common/util/jsx';

import css from './index.styl?inline';
import {template} from './template';

interface NpsSurveyState {
  open: boolean;
  submittedScore: boolean;
  score: number;
  surveyId: string;
  responseText: string;
}

const npsSurveyApiUrl = `/api/app/nps_survey`;

export class NpsSurvey extends Component<NpsSurveyState> {
  get config() {
    return {
      css,
      template,
      useShadowDom: true,

      defaultState: {
        open: true,
        submittedScore: false,
        score: null,
        surveyId: null,
        responseText: ``,
      },

      helpers: {
        getScores: () => {
          return range(11);
        },

        handleClickScore: async (score) => {
          // Transition to the next screen right away rather than waiting for ui responsive
          this.update({submittedScore: true, score});
          const response = await apiClient.post<{survey_id: string}>(`${npsSurveyApiUrl}/response`, {
            shown_on_url: location.href,
            score,
          });
          this.update({surveyId: response.survey_id});
        },

        handleTextInput: (value: string) => {
          this.update({responseText: value});
        },

        handleClickDismiss: () => {
          mixpanel.track(`NPS Survey - Decline (UI)`, {
            shown_on_url: location.href,
          });
          this.update({open: false});
        },

        handleClickSubmit: () => {
          if (this.state.responseText) {
            apiClient.put(`${npsSurveyApiUrl}/response/${this.state.surveyId}`, {
              text: this.state.responseText,
            });
          }
          mixpanel.track(`NPS Survey - Submitted Score (UI)`, {
            survey_id: this.state.surveyId,
            shown_on_url: location.href,
          });

          this.update({open: false});
        },

        handleModalChange: async (ev) => {
          // TODO: Only consider change events from the modal (not from the textarea)
          if (ev.detail && ev.detail.state === `closed`) {
            try {
              this.helpers.handleClickDismiss();
              if (!this.state.submittedScore) {
                await apiClient.post<any>(`${npsSurveyApiUrl}/decline`, {
                  shown_on_url: location.href,
                });
              }
            } finally {
              this.dispatchEvent(new CustomEvent(`closed`));
            }
          }
        },
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();
    mixpanel.track(`NPS Survey - Shown (UI)`, {
      shown_on_url: location.href,
    });
  }
}

defineAndMakeJsxFactory(`nps-survey`, NpsSurvey);
